import {useTheme} from "styled-components";
import {Icon, Package} from "react-feather";
import {Column, Typography} from "components";
import {SvgIconComponent} from "@mui/icons-material";

interface EndMessageProps {
  data: any[];
  icon?: Icon | SvgIconComponent;
}

export const EndMessage: React.FC<EndMessageProps> = ({data, icon}) => {
  const {blackWhite} = useTheme();
  const Icon = icon ?? Package;

  return (
    <Column marginTop={25} alignItems="center" gap={5}>
      <Icon size={45} style={{fontSize: 45, color: blackWhite}} />
      <Typography textAlign="center" fontSize={14}>
        {!data["length"]
          ? "No se encontraron resultados"
          : "No hay más para mostrar"}
      </Typography>
    </Column>
  );
};
